import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, {
            class: "text-uppercase",
            overline: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.card.brand) + " ", 1),
              (_ctx.label)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 0,
                    label: _ctx.label,
                    color: "primary",
                    "text-color": "white",
                    square: "",
                    size: "sm"
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.card.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode("xxxx-xxxx-xxxx-" + _toDisplayString(_ctx.card.last4), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.expires), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}